// An onChange update with value: "" is an explicit clear. A missing value is derived instead.
export function takesExplicitOnChangeValue(change) {
    return !!change && Object.prototype.hasOwnProperty.call(change, 'value')
}
